<template>
  <main class="home center">
    <el-empty :description="i18n.t('views.notFound.text')" />
  </main>
</template>

<script lang="ts" setup>
  import { useI18n } from 'vue-i18n'

  const i18n = useI18n()
</script>

<style scoped>
  .center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
